/** @jsxImportSource @emotion/react */
import { createStyles, Icon, IconName, Typography, useTheme } from '../..';

export interface Props {
  name: string;
  icon: IconName;
  isActive: boolean;
  showNotificationBadge?: boolean;
}

export const NavbarItem = ({
  name,
  icon,
  isActive,
  showNotificationBadge,
}: Props) => {
  const styles = useStyles();
  const { spacing, palette } = useTheme();

  return (
    <div css={styles.tab}>
      <div css={[styles.link, isActive && styles.activeTab]}>
        <span css={[styles.icon, isActive && styles.activeIcon]}>
          <Icon name={icon} size={spacing.xs} />
        </span>
        <span css={styles.nameMobile}>
          <Typography
            variant={isActive ? 'bodySmallestBold' : 'bodySmallestMedium'}
          >
            {name}
          </Typography>
          {showNotificationBadge && (
            <div css={styles.notificationBadge}>
              <Typography color={palette.danger.default} variant="bodySmall">
                •
              </Typography>
            </div>
          )}
        </span>
        <span css={styles.nameDesktop}>
          <Typography variant="body">{name}</Typography>
          {showNotificationBadge && (
            <div css={styles.notificationBadge}>
              <Typography variant="subtitle">•</Typography>
            </div>
          )}
        </span>
      </div>
    </div>
  );
};

const useStyles = createStyles(({ spacing, palette, breakpoints, shape }) => ({
  tab: {
    padding: spacing.xxs,
    [breakpoints.tabletMedium]: {
      padding: 0,
    },
  },
  nameMobile: {
    position: 'relative',
    marginTop: `calc(${spacing.xxxs}/2)`,
    [breakpoints.tabletMedium]: {
      display: 'none',
    },
  },
  nameDesktop: {
    position: 'relative',
    display: 'none',
    [breakpoints.tabletMedium]: {
      display: 'block',
    },
  },
  icon: {
    svg: {
      color: palette.grey.x500,
    },
    [breakpoints.tabletMedium]: {
      marginRight: spacing.xxxs,
    },
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    color: palette.grey.x500,
    flexDirection: 'column',
    [breakpoints.tabletMedium]: {
      borderRadius: `calc(${shape.borderRadius} / 2)`,
      padding: `${spacing.xxxs} ${spacing.xxs}`,
      flexDirection: 'row',
      '&:hover': {
        backgroundColor: palette.grey.x50,
      },
    },
  },
  activeIcon: {
    svg: {
      color: palette.grey.x900,
      [breakpoints.tabletMedium]: {
        color: palette.primary.default,
      },
    },
  },
  activeTab: {
    p: {
      color: palette.grey.x900,
    },
    [breakpoints.tabletMedium]: {
      backgroundColor: palette.grey.x50,
      p: {
        color: palette.primary.default,
      },
    },
  },
  notificationBadge: {
    p: { color: `${palette.danger.default} !important` },
    position: 'absolute',
    top: `calc(-${spacing.xxxs} )`,
    left: '100%',
  },
}));
